import { Controller, useForm } from "react-hook-form";
import { Button, Form } from "reactstrap";
import MultiSelectionField from "../../../CommonElements/Form/MultiSelectionField";
import getTemplateShift from "../services/getTemplateShift";
import useAxios from "../../../Utils/useAxios";
import { useEffect, useState } from "react";
import getShiftStaf from "../services/getShiftStaf";
import { MonthInputField, SelectionField } from "../../../CommonElements";

const FormGetTemplate = ({ toggle }) => {
  const getCurrentMonth = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}`;
  };

  const { control, handleSubmit, watch } = useForm({
    mode: "onChange",
    defaultValues: {
      periode: getCurrentMonth(),
      lokasi: "",
      untuk: "",
    },
  });
  const selectedLokasi = watch("lokasi");

  const [staf, setStaf] = useState({});

  useEffect(() => {
    getShiftStaf(axiosInstance).then((res) => {
      setStaf(res.data);
    });
  }, []);

  const axiosInstance = useAxios();

  const lokasiOptions = [
    {
      id: "Depok",
      name: "Depok",
    },
    {
      id: "Salemba",
      name: "Salemba",
    },
  ];

  const getTemplate = async (data) => {
    getTemplateShift(axiosInstance, data).then(() => {
      toggle();
    });
  };

  return (
    <Form onSubmit={handleSubmit(getTemplate)}>
      <Controller
        name="periode"
        control={control}
        rules={{
          required: "Harap Pilih Periode",
        }}
        render={({ field, fieldState }) => (
          <MonthInputField
            label={"Periode"}
            isRequired={true}
            fieldState={fieldState}
            {...field}
          />
        )}
      />
      <Controller
        name="lokasi"
        control={control}
        rules={{
          required: "Harap Pilih Lokasi",
        }}
        render={({ field, fieldState }) => (
          <SelectionField
            label={"Lokasi"}
            isRequired={true}
            options={lokasiOptions}
            fieldState={fieldState}
            {...field}
          />
        )}
      />
      <Controller
        name="regular"
        control={control}
        rules={{
          required: "Harap pilih staf",
        }}
        render={({ field, fieldState }) => (
          <MultiSelectionField
            label={"Staf Regular"}
            options={staf}
            fieldState={fieldState}
            {...field}
            isRequired={true}
          />
        )}
      />
      {
        selectedLokasi === 'Depok' && (
          <>
            <Controller
              name="regu_1"
              control={control}
              // rules={{
              //   required: "Harap pilih staf regu 1",
              // }}
              render={({ field, fieldState }) => (
                <MultiSelectionField
                  label={"Regu 1"}
                  options={staf}
                  fieldState={fieldState}
                  {...field}
                  // isRequired={true}
                />
              )}
            />
            <Controller
              name="regu_2"
              control={control}
              // rules={{
              //   required: "Harap pilih staf regu 2",
              // }}
              render={({ field, fieldState }) => (
                <MultiSelectionField
                  label={"Regu 2"}
                  options={staf}
                  fieldState={fieldState}
                  {...field}
                  // isRequired={true}
                />
              )}
            />
            <Controller
              name="regu_3"
              control={control}
              // rules={{
              //   required: "Harap pilih staf regu 3",
              // }}
              render={({ field, fieldState }) => (
                <MultiSelectionField
                  label={"Regu 3"}
                  options={staf}
                  fieldState={fieldState}
                  {...field}
                  // isRequired={true}
                />
              )}
            />
          </>
        )
      }
      <Button color="primary">Simpan</Button>
    </Form>
  );
};

export default FormGetTemplate;
